import {GET} from "../../../Hooks/RequestV2";
import {ProductListBanner, ProductListBannerContext} from "./types";

export async function getProductListBanners(context?: ProductListBannerContext): Promise<ProductListBanner[]> {
    const searchParams = new URLSearchParams();

    if (context) {
        searchParams.set("filterType", context.filterType);

        if (context.filterId) {
            searchParams.set("filterId", context.filterId);
        }
    }

    const query = searchParams.toString();
    const response = await GET(`/banners/product-list${query ? `?${query}` : ""}`);

    if (!response.ok) {
        throw new Error("Unable to get product list banners.");
    }

    const payload: unknown = await response.json();

    return Array.isArray(payload) ? payload as ProductListBanner[] : [];
}
